exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,300;1,400;1,500&display=swap);", ""]);

// module
exports.push([module.id, "html {\n  font-size: 62.5%;\n  scroll-behavior: smooth; }\n  html * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Roboto', sans-serif; }\n  html body {\n    background-color: #f6f9f9;\n    font-family: 'Roboto', sans-serif; }\n    html body::-webkit-scrollbar {\n      display: none; }\n", ""]);

// exports
